import inlineSVG from "inline-svg";

export const svgInline = function (el) {
    inlineSVG.init(
        {
            svgSelector: "img.svg",
            initClass: "js-inlinesvg",
        },
        function () {
            console.log("All SVGs inlined");
        }
    );
};
